import Card from "./Card";

function BlogGrid({ posts }) {
  return posts.edges.length ? (
    <div className="row row-cols-1 row-cols-md-3 g-4 px-lg-5">
      {posts.edges.map((post, i) => (
        <div key={post.id} className="col">
          <Card {...post} i={i} />
        </div>
      ))}
    </div>
  ) : (
    <h4 className="text-center">No posts yet!</h4>
  );
}

export default BlogGrid;
